import styled from '@emotion/styled';
import * as React from '@emotion/react';
import {
  CardContainerProps,
  CardContainerRootProps
} from '../models/card-props';
import { renderCards } from './card';

export function CardContainer({
  selectedMedia,
  cardClickHandler,
  keyPressHandler,
  componentOrder,
  colorCoding,
  isColorBar,
  barColor,
  isCategoryLabel
}: CardContainerProps) {
  return (
    <CardContainerRoot
      selectedMedia={selectedMedia}
      componentOrder={componentOrder}
      colorCoding={colorCoding}
    >
      {renderCards(
        cardClickHandler,
        keyPressHandler,
        isColorBar,
        isCategoryLabel,
        colorCoding,
        barColor
      )}
    </CardContainerRoot>
  );
}

export const CardContainerRoot = styled.div<CardContainerRootProps>`
  display: flex;
  justify-content: flex-start;
  flex-basis: calc(99.9999% / 12 * 4 - 16px);
  max-width: calc(99.9999% / 12 * 4 - 16px);
  flex-direction: column;
  order: ${(props) => props.componentOrder};
  margin-right: 16px;
  gap: 8px;

  .card {
    &:hover {
      background-color: ${(props) => props.colorCoding.cardHoverColor};

      .bar {
        opacity: 1;
      }
    }

    .bar {
      opacity: 0;
    }
  }

  .card.card${(props) => props.selectedMedia} {
    background-color: ${(props) => props.colorCoding.cardActiveColor};

    &:hover {
      background-color: ${(props) => props.colorCoding.cardActiveColor};
    }

    .bar {
      opacity: 1;
    }
  }

  @media only screen and (max-width: 1023px) {
    flex-basis: 100%;
    max-width: 100%;
    flex-direction: row;
    margin-bottom: 16px;
    order: 1;
    flex-wrap: nowrap;
    margin-right: 0;
    margin-left: 0;
    justify-content: center;
    gap: 32px;

    .card {
      width: calc(33.3333%);
      margin: 0;
    }
  }

  @media only screen and (max-width: 767px) {
    justify-content: flex-start;
    transition: transform 0.3s;
    transform: ${(props) => `translateX(-${(props.selectedMedia - 1) * 100}%)`};
    gap: 0;

    .card {
      width: 100%;
    }
  }
`;
